module.exports = __webpack_public_path__ + "img/header-weddingRingsHearts@2x.0777dcc.webp";